/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Act_PickupInputs */

const vi_cdo_act_pickup = /** @type {(inputs: Cdo_Act_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn`)
};

/**

* @param {Cdo_Act_PickupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_act_pickup = /** @type {((inputs?: Cdo_Act_PickupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Act_PickupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_act_pickup(inputs)
});